import { useNavigate, commonFunctions, toast } from '../utils/npm'
import { extractLink, PATHS } from '../utils/utils'
import transformCompanyName, { TABKEY, useIpoDetailsPageRedirection } from './CommonFunction'
// const { extractLink } = commonFunctions
const { checkUrl, extractWebsiteName, isTodayOrBefore } = commonFunctions

const ApplyButtons = ({ data, ipoCategory, classList, type }) => {
  const navigate = useNavigate()
  const IpoDetailsPageRedirection = useIpoDetailsPageRedirection(); // Call the hook inside a component

  const handleClickCompanyDetails = async (eve, data1) => {

    eve.preventDefault()

    const trformCompanyName = await IpoDetailsPageRedirection(data1?.new_symbol, data1?.company_name, data, 'ipo-details')
    // navigate(`/ipo/${trformCompanyName}/${data1?.symbol}` , { state: { ipoDetailsData: data1 } })
  }

  const handleCheckAllotment = (e, link) => {
    let website = extractWebsiteName(link)

    if (website) {
      if (!/^https?:\/\//i.test(website)) {
        website = 'https://' + website
      }
      window.open(website, '_blank')
    } else {
      toast.error('Invalid website URL')
    }
  }

  const handleApplyPreAppy = (e, ele) => {
    e.preventDefault()
    let token = localStorage.getItem("login") ? JSON.parse(localStorage.getItem("login")) : null;
    if (token) {
      navigate(`/apply/${ele.symbol}`)
    } else {
      navigate(`/login`)
    }
  }

  const handleAllotment = (e, ele) => {
    e.preventDefault()
    if (!ele || !ele.end_date) {
      toast.error('Invalid data')
      return
    }
    if (isTodayOrBefore(ele.end_date)) {
      toast.info('Coming Soon!')
      // navigate(`/apply/${ele.symbol}`)
      return
    }
    let website = extractWebsiteName(ele.registrar_detail)
    if (website) {
      if (!/^https?:\/\//i.test(website)) {
        website = 'https://' + website
      }
      window.open(website, '_blank')
    } else {
      toast.error('Invalid website URL')
    }
  }

  return (
    <div className={`${classList}`}>

      {
        ipoCategory && (<>
          {
            !data?.is_hold && (<>
              {ipoCategory == 'live' &&
                (isTodayOrBefore(data?.end_date) ? (
                  <button
                    className='btn-primary home-primary-button_1'
                    onClick={e => handleApplyPreAppy(e, data)}
                  >
                    Apply Now
                  </button>
                ) : (<>
                  <button
                    className='btn-primary home-primary-button_1'
                    // onClick={e => handleAllotment(e, data)}
                    onClick={() => {
                      IpoDetailsPageRedirection(data?.symbol, data?.company_name, ' ', TABKEY?.ALLOTNMENT_TAB)
                    }}
                    disabled={!checkUrl(data)}
                  >
                    Check Allotment
                  </button>
                </>))}

              {ipoCategory == 'upcoming' && (
                <button
                  className={`btn-primary home-primary-button_1  ${data?.bid_lot == 0 ? "disabled_ipo_btn" : ""}`}
                  onClick={e => handleApplyPreAppy(e, data)}
                // disabled={e=> data.bid_lot === 0 ? true : false}
                >
                  Pre-Apply
                </button>
              )}

              {ipoCategory == 'listed' && (
                <button
                  className='btn-primary home-primary-button_1'
                  disabled={extractLink(data?.registrar_detail) === '' ? true : false}
                  // onClick={e => handleCheckAllotment(e, data?.registrar_detail)}
                  onClick={() => {
                    IpoDetailsPageRedirection(data?.symbol, data?.company_name, ' ', TABKEY?.ALLOTNMENT_TAB)
                  }}
                >
                  <a >
                    Check Allotment
                  </a>
                </button>
              )}
            </>)
          }
          {type == "" && <button
            className='btn btn-primary home-primary-button max-w-[200px] mx-auto block'
            // onClick={eve => handleClickCompanyDetails(eve, data.symbol)}
            onClick={eve => handleClickCompanyDetails(eve, data)}
          >
            View Details
          </button>}
        </>)
      }

    </div>
  )

}

export default ApplyButtons
